// extracted by mini-css-extract-plugin
var _1 = "BirdviewChartCatalog-moduledropdown__CUrj6 FloatingSelectDropdown-moduledropdown__O8nBT";
export { _1 as "dropdown" }
